/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import RetrieveUsernameSection from './RetrieveUsernameSection';
import messages from 'src/shared/app/authentication/l10n/retrieveUsernameL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';

const RetrieveUsernameMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.heading)}</DocumentTitle>
      <RetrieveUsernameSection />
    </React.Fragment>
  );
};

export default compose(React.memo)(RetrieveUsernameMain);
